import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faMapMarkerAlt, faInfo } from '@fortawesome/free-solid-svg-icons';
import QuranCard from './QuranCard';
import GeneralCard from './GeneralCard';
import WeeklyCard from './WeeklyCard';
import PrayersContainer from './PrayersContainer';
import { StateStore } from '../store';

export default function Home({ currTime, setAboutModal, setSettingsModal }) {
  const { state } = useContext(StateStore);
  const { preferences } = state;
  const location = preferences?.location || null;
  return (
    <>
      <div className="main">
        <WeeklyCard></WeeklyCard>
        <PrayersContainer currTime={currTime}></PrayersContainer>
      </div>
      <div className="side">
        {/* <Clock format={'HH:mm'} ticking={true} className="card clock" /> */}
        <QuranCard></QuranCard>

        <GeneralCard text={location ? (location?.city + ", " + location?.country) : ''}>
          <FontAwesomeIcon icon={faMapMarkerAlt}></FontAwesomeIcon>
          {!location ? <div className="filler" style={{display: "inline-block", width: "60%"}}></div> : null}
        </GeneralCard>
        <GeneralCard className="only-desktop" text="Preferences" onClick={() => setSettingsModal(true)}>
          <FontAwesomeIcon icon={faCog}></FontAwesomeIcon>
        </GeneralCard>
        <GeneralCard text="About & What's New" onClick={() => setAboutModal(true)}>
          <FontAwesomeIcon icon={faInfo}></FontAwesomeIcon>
        </GeneralCard>
      </div>
    </>
  )
}
